import React, { useState, useEffect,useRef } from "react";
import { Card, Button, Form, Row, Col, Table,Modal,Dropdown } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { var_api } from "../../../constant";
import { Link, useNavigate, useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
const InvoiceMaster = () => {
  const [data, setData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
const navigate = useNavigate();
 const inSummaryRef = useRef(null);
const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showFormPage, setShowFormPage] = useState(false);
  const [editId, setEditId] = useState(null);
const [showMailCard, setShowMailCard] = useState(false);
const [toEmail, setToEmail] = useState("");
const [ccEmail, setCcEmail] = useState("");
const [subject, setSubject] = useState("");
const [body, setBody] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 15;
const [showBulkModal, setShowBulkModal] = useState(false);
const [bulkItems, setBulkItems] = useState([]);
const [bulkSearch, setBulkSearch] = useState("");
    const warehouse_id = localStorage.getItem("warehouse_id");
const [showDraftPage, setShowDraftPage] = useState(false);
const [draftData, setDraftData] = useState(null); 

// Assuming you have a list of products to select from
const [products, setProducts] = useState([]);
// For warehouse

// For loading spinner
const [initialLoading, setInitialLoading] = useState(false);

// For storing list of bills (status = 1)
const [adjustments, setAdjustments] = useState([]);

// For controlling screen stage (table / form)
const [showStage, setShowStage] = useState("table");

  const initialState = {
    cust_id: "",
    order_id: "",
    invoice_date: "",
    due_date: "",
    subject: "",
    terms: "",
    customer_notes: "",
    subtotal: "",
    total: "",
    paid_amount: 0,
    balance_amount: "",
        status: 0,
    warehouse_id: warehouse_id,
  };

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
const fetchProductData = async () => {
  try {
    const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
    const allProducts = Array.isArray(res.data)
      ? res.data
      : Array.isArray(res.data.data)
      ? res.data.data
      : [];
    setProducts(allProducts);
  } catch (err) {
    toast.error("Failed to fetch product data");
  }
};

const fetchAdjustments = async () => {
  try {
    setInitialLoading(true);
    const currentWarehouseId = warehouse_id ;

    const res = await axios.get(
      `${var_api}veemart_instore_pos_billing/getbywarehouse/${currentWarehouseId}`
    );

    const allData = res.data || [];

    // 🔥 Filter status = 1
    const filtered = allData.filter(item => item.payment_status === 1);

    setAdjustments(filtered);

    if (filtered.length > 0) setShowStage("table");

  } catch (err) {
    console.error("Error fetching adjustments", err);
  } finally {
    setInitialLoading(false);
  }
};

  // -------------------- Fetch Invoice List --------------------
  const fetchData = async () => {
    try {
      const res = await axios.get(`${var_api}veemart-invoice/getby-warehouse/${warehouse_id}`);
      setData(res.data || []);
    } catch (err) {
      toast.error("Failed to fetch data");
    }
  };

  // -------------------- Fetch Customers --------------------
   const fetchCustomerData = async () => {
     try {
       const res = await axios.get(`${var_api}veemart_instore_customers/get`);
       setCustomerData(res.data || []);
     } catch {
       toast.error("Failed to fetch customer data");
     }
   };

  useEffect(() => {
    fetchData();
    fetchCustomerData();
    fetchProductData();
    fetchAdjustments();
    fetchPaymodeData();
  }, []);
const handleRecordPayment = async (draft) => {
  // Pre-fill modal data
  setPaymentData({
    invoice_id: draft.invoice_id,
    paymode_id: "",
    paid_amount: draft.balance_amount || 0,
    paid_date: new Date().toISOString().split("T")[0],
    remarks: "",
  });

  // Hide other views
  setShowFormPage(false);
  setShowDraftPage(false);
  setShowMailCard(false);

  setShowPaymentCard(true);

  // Fetch existing payments
  try {
    const res = await axios.get(
      `${var_api}veemart-posInvoicePaymodes/get-invoice/${draft.invoice_id}`
    );
    setExistingPayments(res.data || []);
  } catch (err) {
    toast.error("Failed to fetch existing payments");
  }
};
const handlePaymentChange = (field, value) => {
  setPaymentData({ ...paymentData, [field]: value });
};
const handlePaymentSubmit = async () => {
  if (!paymentData.paymode_id || !paymentData.paid_amount) {
    toast.error("Please fill all required fields");
    return;
  }

  const payload = {
    invoice_id: draftData.invoice_id,
    paymode_id: paymentData.paymode_id,
    paid_amount: paymentData.paid_amount,
    paid_date: new Date().toISOString().split("T")[0],
    remarks: paymentData.remarks || ""
  };

  try {
    await axios.post(
      `${var_api}veemart-posInvoicePaymodes/post`,
      payload
    );

    toast.success("Payment recorded successfully!");

    // 🔥 INSTANT UI UPDATE (show Paid in table)
    setData(prev =>
      prev.map(item =>
        item.invoice_id === draftData.invoice_id
          ? { ...item, status: 2 }   // ➜ 2 = Paid
          : item
      )
    );

    // Close payment card
    setShowPaymentCard(false);

    // Optional background refresh
    fetchAdjustments();
    fetchData();

  } catch (err) {
    console.error(err);
    toast.error("Failed to record payment");
  }
};




  // -------------------- Input Change --------------------
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // -------------------- Validation --------------------
  const validate = () => {
    let temp = {};
     if (!formData.cust_id) temp.cust_id = "Customer is required";
    if (!formData.order_id) temp.order_id = "Order ID is required";
    if (!formData.total) temp.total = "Total amount is required";
    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  // -------------------- Add / Update --------------------
 const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validate()) return;

  // Prepare payload
  const payload = {
    ...formData,
    
    cust_id: Number(formData.cust_id),
    details: details.map((item) => ({
      product_id: products.find(p => p.product_name === item.product_name)?.id,
      qty: item.qty,
      unit_price: item.unit_price,
      discount_amt: item.discount_amt || 0,
      total: item.total,
    })),
  };

  try {
  let res;
if (editId) {
  res = await axios.put(
    `${var_api}veemart-invoice/update/${formData.invoice_id}`,
    payload
  );
} else {
  res = await axios.post(`${var_api}veemart-invoice/post`, payload);
}


    fetchData();
    setShowFormPage(false);
    setFormData(initialState);
    setEditId(null);
    setDetails([{ product_name: "", qty: "", unit_price: "", total: "", discount_amt: "" }]);
  } catch (err) {
    toast.error("Failed to save data");
  }
};
const getProductName = (id) => {
  const p = products.find((item) => item.id === id);
  return p ? p.product_name : "-";
};
const formatDate = (dateString) => {
  if (!dateString) return "-";
  const d = new Date(dateString);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};
const toInputDate = (dateString) => {
  if (!dateString) return "";
  const d = new Date(dateString);
  return d.toISOString().slice(0, 10);  // ✔ YYYY-MM-DD
};

 const handleEdit = (row) => {

  setFormData({
    ...row,
    status: row.status ?? 0,
    invoice_date: toInputDate(row.invoice_date), // ✔ input format
    due_date: toInputDate(row.due_date),
  });

  setEditId(row.invoice_id);

  if (Array.isArray(row.details) && row.details.length > 0) {
    setDetails(
      row.details.map((d) => ({
        product_name: d.product_name || getProductName(d.product_id),
        qty: d.qty || "",
        unit_price: d.unit_price || "",
        discount_amt: d.discount_amt || "",
        total: d.total || "",
      }))
    );
  } else {
    setDetails([
      { product_name: "", qty: "", unit_price: "", discount_amt: "", total: "" }
    ]);
  }

  setShowFormPage(true);
  setShowDraftPage(false);
};
;


const handleInvoiceStatusClick = async (row) => {
  setSelectedInvoice(row);

  const invoice_id = row.invoice_id;
  localStorage.setItem("invoice_id", invoice_id);

  try {
    const res = await axios.get(
      `${var_api}veemart-invoice/get/${invoice_id}`
    );

    const invoiceDetails = res.data || {};

    setDraftData(invoiceDetails);   // <-- full invoice + items will fill
    setDetails(invoiceDetails.details || []); // <-- item table fills

    // UI Controls
    setShowDraftPage(true);
    setShowFormPage(false);
    setShowMailCard(false);

  } catch (err) {
    toast.error("Failed to fetch invoice details");
  }
};
const [showPaymentCard, setShowPaymentCard] = useState(false);
const [paymodeData, setPaymodeData] = useState([]);
const [paymentData, setPaymentData] = useState({
  invoice_id: "",
  paymode_id: "",
  paid_amount: "",
  paid_date: new Date().toISOString().split("T")[0],
  remarks: "",
});
const fetchPaymodeData = async () => {
  try {
    const res = await axios.get(`${var_api}paymode_master/get`);
    setPaymodeData(res.data || []);
  } catch {
    toast.error("Failed to fetch payment mode data");
  }
};

const [existingPayments, setExistingPayments] = useState([]);

const [details, setDetails] = useState([
  { product_name: "", qty: "", unit_price: "", total: "", discount_amt: "" }
]);
// Add a new row
const handleAddRow = () => {
  setDetails([
    ...details,
    { product_name: "", qty: "", unit_price: "", total: "", discount_amt: "" }
  ]);
};

// Remove a row
const handleRemoveRow = (index) => {
  const updated = [...details];
  updated.splice(index, 1);
  setDetails(updated);
};

// Handle input change per row
const handleDetailChange = (index, field, value) => {
  const updated = [...details];
  updated[index][field] = value;

  // Automatically calculate total if qty or unit_price changes
  if (field === "qty" || field === "unit_price") {
    const qty = Number(updated[index].qty) || 0;
    const price = Number(updated[index].unit_price) || 0;
    updated[index].total = qty * price - (Number(updated[index].discount_amt) || 0);
  }

  setDetails(updated);
};
const handleDownloadPDF = async () => {
  if (!inSummaryRef.current) {
    toast.error("Right section not found!");
    return;
  }

  const input = inSummaryRef.current;
  const canvas = await html2canvas(input, { scale: 2 });
  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  pdf.save("AdjustmentDetails.pdf");
};

const handlePrint = () => {
  if (!inSummaryRef.current) {
    toast.error("Right section not found!");
    return;
  }

  const printContent = inSummaryRef.current.innerHTML;
  const win = window.open("", "", "height=700,width=900");
  win.document.write("<html><head><title>Print</title></head><body>");
  win.document.write(printContent);
  win.document.write("</body></html>");
  win.document.close();
  win.print();
};

const bulkFilteredProducts = products.filter(p =>
  p.product_name.toLowerCase().includes(bulkSearch.toLowerCase())
);

const handleBulkAdd = (product) => {
  if (!bulkItems.find(b => b.id === product.id)) {
    setBulkItems([...bulkItems, { ...product, qty: 1 }]);
  }
};


const [selectedInvoice, setSelectedInvoice] = useState(null);
const handleSendMailClick = (invoice) => {
  setSelectedInvoice(invoice);
  setToEmail(""); // Reset or prefill if needed
  setCcEmail("");
  setSubject(`Invoice – ${invoice.invoice_no}`);
  setBody(""); // Prefill body if needed
  setShowMailCard(true);

  // Hide other pages
  setShowFormPage(false);
  setShowDraftPage(false);
};
const [subTotal, setSubTotal] = useState(0);
const [discount, setDiscount] = useState(0);
const [total, setTotal] = useState(0);
useEffect(() => {
  // Calculate subtotal based on item table
  const st = details.reduce((acc, item) => {
    const qty = Number(item.qty) || 0;
    const price = Number(item.unit_price) || 0;
    const discountAmt = Number(item.discount_amt) || 0;
    return acc + (qty * price - discountAmt);
  }, 0);

  setSubTotal(st);

  // Total = subtotal - discount (summary discount box)
  const t = st - discount;
  setTotal(t > 0 ? t : 0);

  // Update formData automatically
  setFormData((prev) => ({
    ...prev,
    subtotal: st,
    total: t,
    balance_amount: t,  // balance = total due
  }));
}, [details, discount]);

const handleMarkAsConfirmed = async () => {
  try {
    const payload = {
      id: draftData.invoice_id,
      status: 1,
    };

    await axios.put(
      `${var_api}veemart-invoice/update/${draftData.invoice_id}`,
      payload
    );

    toast.success("Invoice marked as confirmed!");

    // ❗ Once confirmed → open payment card
    setShowPaymentCard(true);
 fetchData();
  } catch (error) {
    console.error(error);
    toast.error("Failed to update status");
  }
};



const handleBulkRemove = (index) => {
  const updated = [...bulkItems];
  updated.splice(index, 1);
  setBulkItems(updated);
};

const handleBulkQtyChange = (index, value) => {
  const updated = [...bulkItems];
  updated[index].qty = value;
  setBulkItems(updated);
};

  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentRows = data.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(data.length / rowsPerPage);

  return (
    <>
      <ToastContainer />

      {/* ----------------------- TABLE PAGE ----------------------- */}
{!showFormPage && !showDraftPage && !showMailCard && !showPaymentCard && (
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <h5>Invoice Master</h5>
            <Button variant="secondary"
              onClick={() => {
                setShowFormPage(true);
                setEditId(null);
                setFormData(initialState);
              }}
            >
              + Add Invoice
            </Button>
          </Card.Header>

          <Card.Body>
            <Table >
              <thead>
                <tr>
                  <th>#</th>
                  <th>Invoice No</th>
                  <th>Customer</th>
                  <th>Invoice Date</th>
                  <th>Total</th>
                  <th>Paid</th>
                  <th>Balance</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {currentRows.map((row, i) => (
                  <tr key={row.id}>
                    <td>{i + 1 + indexOfFirst}</td>
                     <td>{row.invoice_no}</td>
                      <td>{row.customer_name}</td>
                             <td>{formatDate(row.invoice_date)}</td>

                    <td>{row.total}</td>
                    <td>{row.paid_amount}</td>
                    <td>{row.balance_amount}</td>
 <td>
  {row.status === 0 ? (
    <span
      className="badge bg-secondary"
      style={{ cursor: "pointer" }}
      onClick={() => handleInvoiceStatusClick(row)}
    >
      Draft
    </span>
  ) : row.status === 1 ? (
    <span
      className="badge bg-primary"
      style={{ cursor: "pointer" }}
      onClick={() => handleInvoiceStatusClick(row)}
    >
      Confirmed
    </span>
  ) : row.status === 2 ? (
    <span
      className="badge bg-success"
      style={{ cursor: "pointer" }}
      onClick={() => handleInvoiceStatusClick(row)}
    >
      Paid
    </span>
  ) : null}
</td>




            
                  </tr>
                ))}
              </tbody>
            </Table>

     <div className="d-flex justify-content-end mt-3">
                       {[...Array(totalPages)].map((_, idx) => (
                         <Button
                           key={idx}
                           variant={currentPage === idx + 1 ? "primary" : "light"}
                           onClick={() => setCurrentPage(idx + 1)}
                           className="me-1"
                         >
                           {idx + 1}
                         </Button>
                       ))}
                     </div>
          </Card.Body>
        </Card>
      )}

      {/* ----------------------- FORM PAGE ----------------------- */}
{showFormPage && !showDraftPage && (
  <Card className="shadow-lg p-4" style={{ borderRadius: "14px" }}>
    <Card.Header className="d-flex justify-content-between align-items-center">
      <h5 className="mb-0">{editId ? "Edit Invoice" : "Add Invoice"}</h5>
      <Button
        variant="secondary"
        onClick={() => setShowFormPage(false)}
        style={{ borderRadius: "6px" }}
      >
        Back
      </Button>
    </Card.Header>

    <Card.Body>
      <Form onSubmit={handleSubmit}>
        <Row className="g-3">
          {/* Customer */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>
                Customer <span className="text-danger">*</span>
              </Form.Label>
              <Select
                key={`customer-select-${formData.cust_id}`}
                options={customerData.map((cust) => ({
                  value: String(cust.id),
                  label: cust.customer_name,
                }))}
                placeholder="Select or search customer..."
                value={
                  formData.cust_id && formData.customer_name
                    ? { value: String(formData.cust_id), label: formData.customer_name }
                    : null
                }
                onChange={(selected) => {
                  if (selected) {
                    setFormData({ ...formData, cust_id: selected.value, customer_name: selected.label });
                  } else {
                    setFormData({ ...formData, cust_id: "", customer_name: "" });
                  }
                }}
                isSearchable
                isClearable
                closeMenuOnSelect
                menuShouldScrollIntoView={false}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: errors.customer_name ? "#dc3545" : "#ced4da",
                    borderRadius: "6px",
                    boxShadow: "none",
                    minHeight: "42px",
                    "&:hover": { borderColor: "#86b7fe" },
                  }),
                }}
              />
              {errors.customer_name && <small className="text-danger">{errors.customer_name}</small>}
            </Form.Group>
          </Col>

          {/* Order ID */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>
                Order ID <span className="text-danger">*</span>
              </Form.Label>
              <Select
                options={adjustments.map((item) => ({
                  value: item.id,
                  label: item.bill_number,
                }))}
                placeholder="Search Bill Number..."
                value={
                  formData.order_id
                    ? adjustments
                        .map((item) => ({ value: item.id, label: item.bill_number }))
                        .find((opt) => opt.value === Number(formData.order_id))
                    : null
                }
                onChange={(selected) => setFormData({ ...formData, order_id: selected ? selected.value : "" })}
                isSearchable
                isClearable
                closeMenuOnSelect
                menuShouldScrollIntoView={false}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: "6px",
                    minHeight: "42px",
                    "&:hover": { borderColor: "#86b7fe" },
                  }),
                }}
              />
              {errors.order_id && <small className="text-danger">{errors.order_id}</small>}
            </Form.Group>
          </Col>

          {/* Invoice Date */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>Invoice Date</Form.Label>
              <Form.Control
                type="date"
                name="invoice_date"
                value={formData.invoice_date}
                onChange={handleInputChange}
                style={{ borderRadius: "6px", height: "42px" }}
              />
            </Form.Group>
          </Col>

          {/* Due Date */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>Due Date</Form.Label>
              <Form.Control
                type="date"
                name="due_date"
                value={formData.due_date}
                onChange={handleInputChange}
                style={{ borderRadius: "6px", height: "42px" }}
              />
            </Form.Group>
          </Col>

          {/* Subject */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                placeholder="Enter invoice subject..."
                style={{ borderRadius: "6px", height: "42px" }}
              />
            </Form.Group>
          </Col>

          {/* Terms */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>Terms</Form.Label>
              <Form.Control
                type="text"
                name="terms"
                value={formData.terms}
                onChange={handleInputChange}
                placeholder="Payment terms..."
                style={{ borderRadius: "6px", height: "42px" }}
              />
            </Form.Group>
          </Col>

          {/* Customer Notes */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>Customer Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="customer_notes"
                value={formData.customer_notes}
                onChange={handleInputChange}
                placeholder="Enter any notes for the customer..."
                style={{ borderRadius: "6px" }}
              />
            </Form.Group>
          </Col>

          {/* Subtotal */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>Subtotal</Form.Label>
              <Form.Control
                type="number"
                name="subtotal"
                value={formData.subtotal}
                readOnly
                style={{ borderRadius: "6px", backgroundColor: "#f8f9fa", height: "42px" }}
              />
            </Form.Group>
          </Col>

          {/* Total */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>
                Total <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                name="total"
                value={formData.total}
                readOnly
                style={{ borderRadius: "6px", backgroundColor: "#f8f9fa", height: "42px" }}
              />
              {errors.total && <small className="text-danger">{errors.total}</small>}
            </Form.Group>
          </Col>
        </Row>

        {/* Items Table */}
        <h5 className="fw-bold text-secondary border-bottom pb-2 mt-4">Item Table</h5>
        <Table bordered hover responsive className="shadow-sm rounded mt-3 text-center">
          <thead className="bg-light">
            <tr>
              <th>Product</th>
              <th>Qty</th>
              <th>Unit Price</th>
              <th>Total</th>
              <th>Discount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {details.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-muted py-3">
                  No items added yet
                </td>
              </tr>
            ) : (
              details.map((item, idx) => (
                <tr key={idx}>
                  {["product_name", "qty", "unit_price", "total", "discount_amt"].map((field, i) => (
                    <td key={i}>
                      <Form.Control
                        type={field === "product_name" ? "text" : "number"}
                        value={item[field]}
                        onChange={(e) => handleDetailChange(idx, field, e.target.value)}
                        placeholder={field === "product_name" ? "Product Name" : ""}
                        readOnly={field === "total"}
                        className={`shadow-sm rounded ${field === "total" ? "bg-light" : ""}`}
                      />
                    </td>
                  ))}
                  <td>
                    <Button
                      variant="danger"
                      size="sm"
                      className="rounded-pill px-3"
                      onClick={() => handleRemoveRow(idx)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>

        <div className="d-flex gap-4 mb-4">
          <Button variant="link" className="p-0 fw-semibold" onClick={handleAddRow}>
            + Add New Row
          </Button>
          <Button variant="link" className="p-0 fw-semibold" onClick={() => setShowBulkModal(true)}>
            + Add Items in Bulk
          </Button>
        </div>

        {/* Billing Summary */}
        <h5 className="fw-bold text-secondary border-bottom pb-2 mb-3">Billing Summary</h5>
        <Card className="p-3 shadow-sm mb-3" style={{ borderRadius: "8px", maxWidth: "320px" }}>
          <div className="d-flex justify-content-between mb-2">
            <span className="fw-semibold">Sub Total</span>
            <span className="fw-bold">{subTotal.toFixed(2)}</span>
          </div>
          <div className="d-flex justify-content-between mb-2 align-items-center">
            <span className="fw-semibold">Discount</span>
            <Form.Control
              type="number"
              value={discount}
              onChange={(e) => setDiscount(Number(e.target.value))}
              style={{ width: "80px", fontSize: "0.85rem", padding: "2px 6px", borderRadius: "6px" }}
              className="shadow-sm"
            />
          </div>
          <hr />
          <div className="text-center">
            <h6 className="fw-bold">Total: {total.toFixed(2)}</h6>
          </div>
        </Card>

        {/* Submit / Cancel */}
        <div className="d-flex justify-content-end gap-2">
          <Button
            variant="secondary"
            type="submit"
            disabled={loading}
            style={{ borderRadius: "6px", minWidth: "120px" }}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Saving...
              </>
            ) : editId ? "Update" : "Save as Draft"}
          </Button>

          <Button
            variant="danger"
            style={{ borderRadius: "6px", minWidth: "120px" }}
            onClick={() => setShowCancelConfirm(true)}
            disabled={loading}
          >
            Cancel
          </Button>
        </div>
      </Form>
    </Card.Body>
  </Card>
)}

<Modal
  show={showCancelConfirm}
  onHide={() => setShowCancelConfirm(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title className="text-danger fw-bold">
      <i className="fas fa-exclamation-triangle me-2 text-warning"></i>
      Leave this page?
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p>If you leave, your unsaved changes will be discarded.</p>
  </Modal.Body>

  <Modal.Footer className="d-flex justify-content-end">
    <Button
      variant="primary"
      className="px-4"
      style={{ borderRadius: "6px", backgroundColor: "#007bff", border: "none" }}
      onClick={() => setShowCancelConfirm(false)}
    >
      Stay Here
    </Button>

   <Button
  variant="light"
  className="px-4 text-dark border"
  style={{ borderRadius: "6px", backgroundColor: "#e0e0e0" }}
  onClick={() => {
    // Close the confirmation modal
    setShowCancelConfirm(false);

    // Close the form page and return to table
    setShowFormPage(false);

    // Reset editing state (optional but recommended)
    setEditId(null);

    // Clear form data (optional)
    if (typeof setFormData === "function" && initialState) {
      setFormData(initialState);
    }
  }}
>
  Leave & Discard Changes
</Button>

  </Modal.Footer>
</Modal>

       <Modal show={showBulkModal} onHide={() => setShowBulkModal(false)} size="xl">
  <Modal.Header closeButton>
    <Modal.Title>Add Items in Bulk</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div className="row">
      {/* LEFT SIDE PRODUCT LIST */}
      <div className="col-md-6 border-end" style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <input
          type="text"
          className="form-control mb-3"
          placeholder="Search products..."
          value={bulkSearch}
          onChange={(e) => setBulkSearch(e.target.value)}
        />

        {bulkFilteredProducts.map((product, i) => (
          <div key={i} className="d-flex justify-content-between align-items-center border-bottom py-2">
            <span>{product.product_name}</span>
            <button
              className="btn btn-outline-danger btn-sm rounded"
              onClick={() => handleBulkAdd(product)}
            >
              +
            </button>
          </div>
        ))}
      </div>

      {/* RIGHT SIDE SELECTED LIST */}
      <div className="col-md-6" style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <h6 className="fw-bold">Selected Items (Qty)</h6>

        {bulkItems.length === 0 ? (
          <p className="text-muted mt-3">No items selected</p>
        ) : (
          bulkItems.map((item, idx) => (
            <div key={idx} className="d-flex justify-content-between align-items-center border-bottom py-2">
              <div><strong>{item.product_name}</strong></div>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="number"
                  value={item.qty}
                  min="1"
                  className="form-control form-control-sm"
                  style={{ width: "70px" }}
                  onChange={(e) => handleBulkQtyChange(idx, e.target.value)}
                />
                <button className="btn btn-danger btn-sm" onClick={() => handleBulkRemove(idx)}>X</button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button
      style={{ backgroundColor: "#007bff", borderColor: "#007bff", color: "#fff" }}
      onClick={() => {
        setDetails(prev => [
          ...prev,
          ...bulkItems.map(b => ({
            product_name: b.product_name,
            qty: b.qty,
            unit_price: "",
            total: "",
            discount_amt: ""
          }))
        ]);
        setBulkItems([]);
        setShowBulkModal(false);
      }}
    >
      Add Products
    </Button>

    <Button
      style={{ backgroundColor: "#6c757d", borderColor: "#6c757d", color: "#fff" }}
      onClick={() => setShowBulkModal(false)}
    >
      Cancel
    </Button>
  </Modal.Footer>
</Modal>

{showDraftPage && draftData && (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{
      minHeight: "100vh",
      background: "linear-gradient(to bottom right, #f3f4f6, #e5e7eb)",
      padding: "20px",
    }}
  >
    <Card
      className="shadow-lg border-0"
      style={{
        width: "100%",
        maxWidth: "1400px",
        borderRadius: "18px",
        overflow: "hidden",
      }}
    >
      <Card.Body className="p-0">
        <Row className="g-0">

          {/* LEFT PANEL */}
          <Col
            md={3}
            style={{
              backgroundColor: "#f9fafb",
              borderRight: "1px solid #e5e7eb",
              minHeight: "100vh",
            }}
          >
            <div className="p-4">
              <h5 className="fw-bold mb-4 text-dark">
                INVOICE: {draftData.invoice_no}
              </h5>

              <Card
                className="shadow-sm border-0 mb-4 hover-shadow"
                style={{
                  color: "#000",
                  borderRadius: "8px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
              >
                <div className="p-3">
                  <Row>
                    <Col md={6}>
                      <p className="mb-2">
                        <strong>Customer:</strong>{" "}
                        {
                           draftData.customer_name
                         
                        }
                      </p>

                      <p className="mb-2">
                        <strong>Invoice No:</strong> {draftData.invoice_no}
                      </p>
                    </Col>

                    <Col md={6} className="text-md-end">
                    <p className="mb-2">
  <strong>Date:</strong>{" "}
  {draftData.invoice_date
    ? (() => {
        const d = new Date(draftData.invoice_date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      })()
    : "-"}
</p>

                    </Col>
                  </Row>
                </div>
              </Card>
            </div>

            <style jsx>{`
              .hover-shadow:hover {
                transform: translateY(-3px);
                box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
              }
            `}</style>
          </Col>

          {/* RIGHT PANEL */}
          <Col md={9}>
            <div className="p-4">

              {/* TOP BAR */}
              <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                <div className="d-flex align-items-center gap-3">
                  <Button
                    variant="outline-dark"
                    size="sm"
                    onClick={() => {
                      setShowDraftPage(false);
                      setDraftData(null);
                    }}
                    className="rounded-pill px-3"
                  >
                    <i className="fas fa-arrow-left me-2"></i>Back
                  </Button>

                  <h4 className="fw-bold mb-0 text-dark">
                    Invoice #{draftData.invoice_no}
                  </h4>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <Button
  variant="outline-primary"
 size="sm"
  onClick={handleMarkAsConfirmed}
>
  Mark as Confirmed
</Button>

                  <Button
  variant="outline-primary"
  size="sm"
  onClick={() => handleRecordPayment(draftData)}
>
  Record Payment
</Button>

                  <Button 
  variant="outline-primary" 
  size="sm" 
  onClick={() => handleSendMailClick(draftData)}
>
  <i className="fas fa-envelope me-2"></i>Send Mail
</Button>


                 <Button
  variant="primary"
  size="sm"
  className="rounded-pill px-3"
  onClick={() => handleEdit(draftData)}
>
  <i className="fas fa-edit me-2"></i>Edit
</Button>


                  <Dropdown>
                    <Dropdown.Toggle variant="outline-dark" size="sm" className="rounded-pill px-3">
                      <i className="fas fa-file-pdf me-2"></i>PDF / Print
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={handleDownloadPDF}>
                        <i className="fas fa-download me-2"></i>Download PDF
                      </Dropdown.Item>
                      <Dropdown.Item onClick={handlePrint}>
                        <i className="fas fa-print me-2"></i>Print
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              {/* MAIN INVOICE CARD */}
              <div ref={inSummaryRef} className="position-relative d-flex justify-content-center mb-4">
                <Card
                  className="shadow border-0 position-relative"
                  style={{
                    width: "100%",
                    maxWidth: "850px",
                    borderRadius: "14px",
                    backgroundColor: "#ffffff",
                  }}
                >

                  {/* RIBBON */}
                  <div
                    style={{
                      position: "absolute",
                      top: "20px",
                      left: "-35px",
                      backgroundColor:
                        draftData.status === 0
                          ? "#6c757d"
                          : draftData.status === 1
                          ? "#17a2b8"
                          : "#28a745",
                      color: "#fff",
                      transform: "rotate(-45deg)",
                      width: "160px",
                      textAlign: "center",
                      padding: "6px 0",
                      fontWeight: "700",
                      fontSize: "13px",
                      boxShadow: "0 3px 8px rgba(0,0,0,0.25)",
                    }}
                  >
                    {draftData.status === 0
                      ? "DRAFT"
                      : draftData.status === 1
                      ? "CONFIRMED"
                      : "CONFIRMED"}
                  </div>

             <Card.Body className="p-4" style={{ border: "1px solid #ccc" }}>

  {/* COMPANY + INVOICE TITLE */}
 <Row>
  <Col md={4} className="ms-auto text-end">
    <h1 style={{ fontSize: "34px", letterSpacing: "2px" }}>
      TAX INVOICE
    </h1>
  </Col>
</Row>

  {/* INVOICE DETAILS SECTION */}
  <Row className="mt-4" style={{ borderTop: "1px solid #000", borderBottom: "1px solid #000" }}>
    <Col md={6} className="p-3" style={{ borderRight: "1px solid #000" }}>
      <p><strong># :</strong> {draftData.invoice_no}</p>
<p>
  <strong>Invoice Date :</strong>{" "}
  {draftData.invoice_date
    ? new Date(draftData.invoice_date).toLocaleDateString("en-GB")
    : "-"}
</p>      <p><strong>Terms :</strong> {draftData.payment_terms || "Due on Receipt"}</p>
<p>
  <strong>Due Date :</strong>{" "}
  {draftData.due_date
    ? new Date(draftData.due_date).toLocaleDateString("en-GB")
    : "-"}
</p>
    </Col>
    <Col md={6}></Col>
  </Row>

  {/* ITEM TABLE */}
  <table className="table table-bordered mt-4">
    <thead>
      <tr style={{ backgroundColor: "#efefef" }}>
        <th style={{ width: "50px" }}>#</th>
        <th>Item & Description</th>
        <th style={{ width: "80px" }}>Qty</th>
        <th style={{ width: "100px" }}>Rate</th>
        <th style={{ width: "120px" }}>Amount</th>
      </tr>
    </thead>

    <tbody>
      {draftData?.details?.map((item, i) => (
        <tr key={i}>
          <td>{i + 1}</td>
          <td>{getProductName(item.product_id)}</td>
          <td>{item.qty}</td>
          <td>{item.unit_price}</td>
          <td>{item.total}</td>
        </tr>
      ))}
    </tbody>
  </table>

  {/* TOTAL IN WORDS + TOTAL SUMMARY */}
  <Row className="mt-4">
    <Col md={6} className="p-3">
      <p className="fw-bold">Total in Words</p>
      <p><i>{draftData.amount_in_words}</i></p>

      <p className="fw-bold mt-4">Notes</p>
      <p>Thanks for your business.</p>
    </Col>

    <Col md={6} className="p-3">
      <table className="table">
        <tbody>
          <tr>
            <td className="text-end"><strong>Sub Total</strong></td>
            <td className="text-end">{draftData.subtotal}</td>
          </tr>
          <tr>
            <td className="text-end"><strong>Total</strong></td>
            <td className="text-end fw-bold">Rs.{draftData.total}</td>
          </tr>
          <tr>
            <td className="text-end"><strong>Balance Due</strong></td>
            <td className="text-end fw-bold">Rs.{draftData.balance_amount}</td>
          </tr>
        </tbody>
      </table>
    </Col>
  </Row>

  {/* SIGNATURE SECTION */}
  <Row className="mt-5">
    <Col className="text-end">
      <p className="mt-5">____________________________</p>
      <p>Authorized Signature</p>
    </Col>
  </Row>

</Card.Body>

                </Card>
              </div>
            </div>
          </Col>

        </Row>
      </Card.Body>
 

    </Card>
  </div>
)}

{showMailCard && draftData && (
  <Card className="shadow-lg p-4 mt-4" style={{ borderRadius: "14px" }}>
    <h4 className="mb-4 fw-bold">Send Invoice Mail</h4>

    <Form>
      {/* From */}
      <Form.Group className="mb-3">
        <Form.Label>From</Form.Label>
        <Form.Control
          type="email"
          value={localStorage.getItem("warehouse_email") || ""}
          readOnly
        />
      </Form.Group>

      {/* To */}
      <Form.Group className="mb-3">
        <Form.Label>To</Form.Label>
        <Form.Control
          type="email"
          placeholder="Enter recipient email"
          value={toEmail}
          onChange={(e) => setToEmail(e.target.value)}
        />
      </Form.Group>

      {/* CC */}
      <Form.Group className="mb-3">
        <Form.Label>CC</Form.Label>
        <Form.Control
          type="email"
          placeholder="Enter CC email (optional)"
          value={ccEmail}
          onChange={(e) => setCcEmail(e.target.value)}
        />
      </Form.Group>

      {/* Subject */}
      <Form.Group className="mb-3">
        <Form.Label>Subject</Form.Label>
        <Form.Control
          type="text"
          value={subject || `Invoice – ${draftData.invoice_no || ""}`}
          onChange={(e) => setSubject(e.target.value)}
        />
      </Form.Group>

      {/* Body */}
      <Form.Group className="mb-4">
        <Form.Label>Body</Form.Label>
        <Form.Control
          as="textarea"
          rows={10}
          value={
            body ||
            `Dear ${customerData.find(c => c.cust_id === draftData.cust_id)?.customer_name || ""},\n\n` +
            `Please find attached your Invoice #${draftData.invoice_no} dated ${draftData.invoice_date}.\n\n` +
            `Invoice Details:\n` +
            draftData.details?.map((item, idx) =>
              `${idx + 1}. ${getProductName(item.product_id)} - Qty: ${item.qty}, Unit Price: ₹${item.unit_price}, Total: ₹${item.total}`
            ).join("\n") +
            `\n\nSubtotal: ₹${draftData.subtotal}\nTotal: ₹${draftData.total}\nBalance: ₹${draftData.balance_amount}\n\n` +
            `Regards,\n${localStorage.getItem("warehouse_name") || "Veemart Team"}`
          }
          onChange={(e) => setBody(e.target.value)}
        />
      </Form.Group>

      {/* Action Buttons */}
      <div className="d-flex justify-content-end gap-2">
        <Button
          variant="success"
          onClick={async () => {
            if (!toEmail) {
              toast.error("Recipient email is required!");
              return;
            }

            try {
              // Build HTML email for invoice
              const emailHTML = `
                <p>Dear ${customerData.find(c => c.cust_id === draftData.cust_id)?.customer_name || ""},</p>

                <p>Please find attached your Invoice <b>#${draftData.invoice_no}</b> dated ${draftData.invoice_date}.</p>

                <p>Invoice Details:</p>
                ${draftData.details
                  ?.map(
                    (item, idx) =>
                      `<div>${idx + 1}. ${item.product_name} - Qty: ${item.qty}, Unit Price: ₹${item.unit_price}, Total: ₹${item.total}</div>`
                  )
                  .join("")}

                <p>Subtotal: ₹${draftData.subtotal}</p>
                <p>Total: ₹${draftData.total}</p>
                <p>Balance: ₹${draftData.balance_amount}</p>

                <br/>
                <p>Regards,<br/>${localStorage.getItem("warehouse_name") || "Veemart Team"}</p>
              `;

              await axios.post(`${var_api}sa_veemart_admin/send-email`, {
                from: localStorage.getItem("warehouse_email"),
                to: toEmail,
                cc: ccEmail,
                subject: subject || `Invoice – ${draftData.invoice_no}`,
                html: emailHTML,
              });

              toast.success("Email sent successfully!");
            } catch (err) {
              console.error(err);
              toast.error("Failed to send email");
            }
          }}
        >
          Send Email
        </Button>

        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => setShowMailCard(false)}
        >
          <i className="fas fa-arrow-left me-2"></i>Back
        </Button>
      </div>
    </Form>
  </Card>
)}



{showPaymentCard && paymentData && (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{
      minHeight: "100vh",
      background: "linear-gradient(to bottom right, #f3f4f6, #e5e7eb)",
      padding: "20px",
    }}
  >
    <Card
      className="shadow-lg border-0"
      style={{
        width: "100%",
        maxWidth: "1400px",
        borderRadius: "18px",
        overflow: "hidden",
      }}
    >
      <Card.Body className="p-0">
        <Row className="g-0">

          {/* LEFT PANEL - Customer Info */}
          <Col
            md={3}
            style={{
              backgroundColor: "#f9fafb",
              borderRight: "1px solid #e5e7eb",
              minHeight: "100vh",
            }}
          >
            <div className="p-4">
              <h5 className="fw-bold mb-4 text-dark">Invoice: {draftData.invoice_no}</h5>
              <Card
                className="shadow-sm border-0 mb-4 hover-shadow"
                style={{
                  color: "#000",
                  borderRadius: "8px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
              >
                <div className="p-3">
                  <p className="mb-2"><strong>Customer:</strong> {draftData.customer_name}</p>
                  <p className="mb-2"><strong>Invoice ID:</strong> {draftData.invoice_no}</p>
                  <p className="mb-2"><strong>Invoice Date:</strong> {draftData.invoice_date}</p>
                  <p className="mb-2"><strong>Due Date:</strong> {draftData.due_date}</p>
                </div>
              </Card>
            </div>

            <style jsx>{`
              .hover-shadow:hover {
                transform: translateY(-3px);
                box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
              }
            `}</style>
          </Col>

          {/* RIGHT PANEL - Payment Form */}
          <Col md={9}>
            <div className="p-4">

              {/* TOP BAR */}
              <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                <div className="d-flex align-items-center gap-3">
                  <Button
                    variant="outline-dark"
                    size="sm"
                    onClick={() => setShowPaymentCard(false)}
                    className="rounded-pill px-3"
                  >
                    <i className="fas fa-arrow-left me-2"></i>Back
                  </Button>
                  <h3 className="fw-bold mb-0 text-danger">Record Payment {draftData.invoice_no}</h3>
                </div>
              </div>

  <Card
  className="shadow border-0 p-4"
  style={{ borderRadius: "14px", backgroundColor: "#ffffff" }}
>
  <h5 className="fw-bold mb-4">Invoice {draftData.invoice_no}</h5>

  <Form>
    {/* Customer Name */}
    <Row className="mb-3">
      <Col md={6}>
        <Form.Group>
          <Form.Label className="fw-semibold text-danger">
            Customer Name
          </Form.Label>
          <Form.Control
            type="text"
            value={draftData.customer_name}
            readOnly
            className="shadow-sm"
          />
        </Form.Group>
      </Col>
       <Col md={6}>
        <Form.Group>
          <Form.Label className="fw-semibold text-danger">
            Amount (INR)*
          </Form.Label>
          <Form.Control
            type="number"
            value={paymentData.paid_amount}
            onChange={(e) =>
              handlePaymentChange("paid_amount", e.target.value)
            }
            className="shadow-sm"
          />
        
        </Form.Group>
      </Col>
    </Row>

  

    {/* Payment Date & Mode */}
    <Row className="mb-3">
      <Col md={6}>
        <Form.Group>
          <Form.Label className="fw-semibold text-danger">
            Payment Date
          </Form.Label>
          <Form.Control
            type="date"
            value={paymentData.paid_date}
            onChange={(e) =>
              handlePaymentChange("paid_date", e.target.value)
            }
            className="shadow-sm"
          />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label className="fw-semibold text-danger">Payment Mode </Form.Label>
          <Form.Select
            value={paymentData.paymode_id}
            onChange={(e) =>
              handlePaymentChange("paymode_id", e.target.value)
            }
            className="shadow-sm"
          >
            <option value="">Select Payment Mode</option>
            {paymodeData.map((p) => (
              <option key={p.id} value={p.id}>
                {p.paymode_name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
    </Row>

    {/* Notes */}
    <Row className="mb-3">
      <Col md={6}>
        <Form.Group>
          <Form.Label className="fw-semibold text-danger">Remarks</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={paymentData.remarks}
            onChange={(e) => handlePaymentChange("remarks", e.target.value)}
            className="shadow-sm"
          />
        </Form.Group>
      </Col>
    </Row>

    {/* Buttons */}
    <div className="d-flex justify-content-end gap-2 mt-3">
      <Button variant="success" onClick={handlePaymentSubmit}>
        <i className="fas fa-check me-2"></i>Pay
      </Button>
      <Button variant="danger" onClick={() => setShowPaymentCard(false)}>
        <i className="fas fa-times me-2"></i>Cancel
      </Button>
    </div>
  </Form>
</Card>



            </div>
          </Col>

        </Row>
      </Card.Body>
    </Card>
  </div>
)}




    </>
  );
};

export default InvoiceMaster;
